import React from 'react';
import ListarObjetos from '../../../components/insumos/objetos/ListarObjetos';

const InsumosPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
      <ListarObjetos />
    </div>
  );
};

export default InsumosPage;